import { TourButton } from '@/components/ui/tour-button'
import { useUserGuidePlayer } from '@/hooks/use-user-guide-player'

export const UserGuidePlayer = () => {
  const { startTour, canShowButton } = useUserGuidePlayer()
  if (!canShowButton) return null
  return <TourButton onClick={() => void startTour()} />
}
